import Dexie from 'dexie'

export const db = new Dexie('tokens')

db.version(2).stores({
    metadata: 'token_id, *creators, collectionid',
    images: 'ipfsUri'
})
